import React from 'react';

import ServiceRoutes from './service';
import AccessibilityRoutes from './accessibility';
import ContactRoutes from './contact';
import CookiePolicyRoutes from './cookie-policy';
import FAQRoutes from './faq';
import PrivacyPolicyRoutes from './privacy-policy';
import TosRoutes from './terms-of-service';

import StartLayout from '../start-layout';

const About = () => {
  return (
    <StartLayout>
      <ServiceRoutes />
      <AccessibilityRoutes />
      <ContactRoutes />
      <CookiePolicyRoutes />
      <FAQRoutes />
      <PrivacyPolicyRoutes />
      <TosRoutes />
    </StartLayout>
  );
};

export default About;
